var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6412 1.04601C9.92648 1.04601 7.67188 3.2546 7.67188 5.96933H26.0308C28.7455 5.96933 31.0001 3.76074 31.0001 1H12.6412V1.04601Z",
    fill: "#04AB61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67188 5.96933C7.67188 3.2546 9.88046 1 12.6412 1V19.3589C12.6412 22.0736 10.4326 24.3282 7.67188 24.3282V5.96933Z",
    fill: "#04AB61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2056 7.625V12.5943H19.9571C22.6718 12.5943 24.9264 10.3857 24.9264 7.625H14.2056Z",
    fill: "#FBB016"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5943C1 9.8796 3.20859 7.625 5.96933 7.625V25.9839C5.96933 28.6986 3.76074 30.9532 1 30.9532V12.5943Z",
    fill: "#FBB016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashFree);
export default __webpack_public_path__ + "static/media/cashFree.08ba7d1a7d7a97a588184092b38c14a8.svg";
export { ForwardRef as ReactComponent };